import styled, { css } from "styled-components";
import { Screen, Color, FontSize } from 'styles';

export const StyledWrapper = styled.section`
  background: ${Color.White};
  padding: 60px 0 92px;
  text-align: center;
  width: 100%;
`;

const SmallHeaderStyle = css`
   margin-bottom: 15px;
   font-size: ${FontSize.M};
`;

export const StyledHeader = styled.h2`
  color: ${Color.Black};
  font-size: ${FontSize.XL};
  letter-spacing: 4.1px;
  margin-bottom: 21px;
  text-align: center;
  
  ${Screen.small(SmallHeaderStyle)}
`;

const SmallDescriptionStyle = css`
   font-size: ${FontSize.XXS};
   margin-bottom: 30px;
`;

export const StyledDescription = styled.div`
  color: ${Color.Orange};
  font-size: ${FontSize.M};
  letter-spacing: 3.4px;
  margin-bottom: 43px;
  text-align: center;
  
  ${Screen.small(SmallDescriptionStyle)}
`;


// WEBPACK FOOTER //
// ./src/components/cost/cost.style.js